import styled from "styled-components";

export const Styles = styled.div`
  .ant-input-number-input {
    text-align: right;
    padding: 10px !important;
  }
  .ant-input-number-group-addon {
    display: none;
  }
  .ant-input-number-group-wrapper {
    width: 100%;
  }
  .ant-input-number-group:has(.ant-input-number-input[value]:not([value=""]))
    .ant-input-number-group-addon {
    display: table-cell;
  }
`;
